import { render } from "./mapComponentRecent.vue?vue&type=template&id=69d9fafa"
import script from "./mapComponentRecent.vue?vue&type=script&lang=js"
export * from "./mapComponentRecent.vue?vue&type=script&lang=js"

import "./mapComponentRecent.vue?vue&type=style&index=0&id=69d9fafa&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__